<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex align-center">
        <h2>Utenti tesserati MSP</h2>
        <v-spacer></v-spacer>
        <v-file-input label="Excel Coni" v-model="file" accept=".xls" :disabled="loading" :loading="loading" placeholder="Clicca qui per scegliere il file" hide-details max-width="200"></v-file-input>
        <v-btn size="small" color="primary" :disabled="!file || loading" :loading="loading"  @click="importExcel()"></v-btn>
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-text-field  v-model="query.name" label="Nome" autocomplete="off"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-text-field  v-model="query.number" label="N° tessera" autocomplete="off"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-text-field  v-model="query.cf" label="Cod. fiscale" autocomplete="off"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-select  v-model="query.expired" label="Scadute" :items="expiredOptions" clearable autocomplete="off"></v-select>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <data-table ref="dataTable" :headers="headers" collection="cards" viewable view-sub-path="" :editable="false" deletable :query="query" @error="onListError">
          <template v-slot:item.number="{ item }">
            <a @click="$router.push('/cards/'+item._id)" ><b>{{ item.number }}</b></a>
          </template>
          <template v-slot:item.surname="{ item }">
            <a @click="$router.push('/cards/'+item._id)" ><b>{{ item.surname }}</b> {{ item.name }}</a>
          </template>
          <template v-slot:item.user._id="{ item }">
            <strong  v-if="item.user" class="text-success">Sì</strong>
            <span class="text-error" v-else>No</span>
          </template>

        </data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import {defineComponent, ref, computed, watch, onMounted, inject, onBeforeUnmount, useTemplateRef} from 'vue'
import { useRouter } from 'vue-router'
import utils from '../utils'
import DataTable from "@/components/DataTable.vue";
import {type DataTableError, type Query, UserRole} from "@/models.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import {roles} from "@/consts.ts";
import type {Auth} from "@/plugins/auth.ts";
import api from "@/api";

export default defineComponent({
  name: "UserList",
  components: {DataTable},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const router = useRouter()

    const loading = ref<boolean>(false)
    const file = ref<File|undefined>()
    const dataTable = useTemplateRef<typeof DataTable>('dataTable')
    const query = ref<Query>({})
    // Methods
    const calcAge = (birth: string) => {
      const age = utils.calcAge(birth)
      return age + " anni"
    }



    let wh:any;
    onMounted(async ()=>{
      await auth.waitForLogin
      if(!auth.isAdmin.value) {
        await router.replace("/")
        return
      }

      query.value = utils.getSessionQuery(`cards`)
      wh = watch(query.value, ()=>{
        utils.setSessionQuery("cards", query.value)
      }, { deep: true })
    })
    onBeforeUnmount(()=>{
      if(wh) wh();
    })
    return {
      dataTable,
      loading,
      file,
      UserRole,
      roles,
      formatDateTime : utils.formatDateTime,
      query,
      headers : [
        { title : 'N° Tessera', sortable: true, align: 'left', value : 'number' },
        { title : 'Cognome e nome', sortable: true, align: 'left', value : 'surname' },
        { title : 'Cod. fiscale', sortable: true, align: 'left', value : 'fiscal_code' },
        { title : 'Assicurazione', sortable: true, align: 'left', value : 'insurance' },
        { title : 'Scadenza', sortable: true, align: 'left', value : 'expiration' },
        { title : 'Registrato', sortable: true, align: 'center', value : 'user._id' },
      ],
      onListError(e:DataTableError) {
        if(e.status === 401) {
          messages.error(Msg.permissionError)
          auth.logout()
          return
        }
        messages.error(`Errore: ${e.message}`)
      },
      // Methods
      calcAge,
      expiredOptions : [
        { title: "Sì", value : true},
        { title: "No", value : false},
      ],

      importExcel() {
        if(!file.value) {
          return
        }
        messages.requestConfirm("Richiesta conferma", "Sei sicuro di voler importare questo file?", false, async ok => {
          if(!ok) return
          loading.value = true
          let formData = new FormData();
          formData.append("file", file.value!);

          const res = await api.upload<any>("cards/import", formData)
          loading.value = false
          if(!res.success) {
            messages.error(res.message ?? Msg.serverError)
            return
          }
          if(res.data) {
            await dataTable.value!.loadItems()
            messages.success("Importate " + res.data.length + " tessere!")
          } else {
            messages.success("Nessuna tessera importata!")
          }
        })
      }
    }
  }
})
</script>
